<template>
    <div class="col-lg-10 col-md-8 col-12 main">
        <h1 style="margin-bottom: 10px;">Download List</h1>
        <p style="color: #000;margin-bottom: 30px;">※ Password: accumbens</p>
        <a v-for="item in list" :key="item.name" :href="item.link" download class="link" :onclick="(e) => donwlonad(e)">
            {{ item.name }}
        </a>
    </div>
</template>
<script>
export default {
    name: "home",
    components: {
    },
    donwlonad(e) {
        e.preventDefault();
        console.log("download");        
        window.location.reload();
    },
    data() {
        return {
            list: [
                { name: "Chapter 1 Brain Basics", link: "/downloads/Chapter 1 Brain Basics.pdf" },
                { name: "Chapter 2 Senses and Perception", link: "/downloads/Chapter 2 Senses and Perception.pdf" },
                { name: "Chapter 3 Movement", link: "/downloads/Chapter 3 Movement.pdf" },
                { name: "Chapter 4 Learning Memory and Emotions", link: "/downloads/Chapter 4 Learning Memory and Emotions.pdf" },
                { name: "Chapter 5 Thinking, Planning and Language", link: "/downloads/Chapter 5 Thinking, Planning and Language.pdf" },
                { name: "Chapter 6 The Developing Brain", link: "/downloads/Chapter 6 The Developing Brain.pdf" },
                { name: "Chapter 7 Infant, Child and Adolescent Brain", link: "/downloads/Chapter 7 Infant, Child and Adolescent Brain.pdf" },
                { name: "Chapter 8 Adult and Aging Brain", link: "/downloads/Chapter 8 Adult and Aging Brain.pdf" },
                { name: "Chapter 9 Brain States", link: "/downloads/Chapter 9 Brain States.pdf" },
                { name: "Chapter 10 The Body in Balance", link: "/downloads/Chapter 10 The Body in Balance.pdf" },
                { name: "Chapter 11 Childhood Disorders", link: "/downloads/Chapter 11 Childhood Disorders.pdf" },
                { name: "Chapter 12 Psychiatric Disorders", link: "/downloads/Chapter 12 Psychiatric Disorders.pdf" },
                { name: "Chapter 13 Addiction", link: "/downloads/Chapter 13 Addiction.pdf" },
                { name: "Chapter 14 Injury and Illness", link: "/downloads/Chapter 14 Injury and Illness.pdf" },
                { name: "Chapter 15 Neurodegenerative Diseases", link: "/downloads/Chapter 15 Neurodegenerative Diseases.pdf" },
                { name: "Chapter 16 Kinds of Research", link: "/downloads/Chapter 16 Kinds of Research.pdf" },
                { name: "Chapter 17 Solving Human Problems", link: "/downloads/Chapter 17 Solving Human Problems.pdf" }
            ]
        }
    },


};
</script>
<style scoped>
/* 
*{border:1px solid #000;} */

.main {
    height: 100vh;
    padding: 30px 15px;
}

.link {
    display: block;
    margin-bottom: 10px;
    text-decoration: underline;
}

@media (max-width: 768px) {
    .main {
        padding-top: 0px;
        height: calc(100vh - 90px);
    }

}
</style>
